// extracted by mini-css-extract-plugin
module.exports = {"root":"BestTime-root-2ZUb9","table":"BestTime-table-399aW","cell":"BestTime-cell-1JBBq","footer":"BestTime-footer-GIROL","button":"BestTime-button-3YslU"};